<template>
    <div id="back-forward-buttons" class="lb-btn-container">
        <div class="grey-outline-pill-button" v-on:click="goBackward">Назад</div>
        <div class="disabled-pill-button-of-hate go-next extra-left-margin">Далее</div>
    </div>
</template>

<script>
    export default {
        name: "RightLowerBarBackOnly",
        props: {
            version: {
                type: String
            }
        },
        computed: {
            adjacentSteps() {
                let stepsOrder = this.$store.state.UI.stepsChain[this.version].stepsOrder
                return stepsOrder[this.$store.state.route.name]
            }
        },
        methods: {
            goBackward() {
                this.$router.push({name: this.adjacentSteps.prev}).catch(err=>{});
            }
        }
    }
</script>

<style scoped>

</style>
